import { render, staticRenderFns } from "./Query.vue?vue&type=template&id=81479cac&scoped=true&"
import script from "./Query.vue?vue&type=script&lang=js&"
export * from "./Query.vue?vue&type=script&lang=js&"
import style0 from "./Query.vue?vue&type=style&index=0&id=81479cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81479cac",
  null
  
)

export default component.exports